import type { JSX, ReactNode } from "react";
import type { Template } from "@/common/types/templates";
import { TemplateGroups } from "./template-groups";
import { TemplateItemActions } from "./template-item";

// Classic Templates page: Favorites, My templates and Built-in templates,
// each row with a star, "Set as default", and edit / delete for your own.
export const TemplatesList = ({
  templates,
  emptyYours,
}: {
  templates: Template[];
  emptyYours?: ReactNode;
}): JSX.Element => (
  <TemplateGroups
    actionsClassName="w-[88px] lg:w-[72px]"
    emptyYours={emptyYours}
    renderActions={(template) => <TemplateItemActions template={template} />}
    templates={templates}
  />
);
